import { render, staticRenderFns } from "./ClientChip.vue?vue&type=template&id=56900540"
import script from "./ClientChip.vue?vue&type=script&lang=js"
export * from "./ClientChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports